import { ClientFetch } from '../../fetch/ClientFetch';
import { HTTP_METHODS } from 'utils';

/**
 * Adds a voucher to the current shopping cart.
 *
 * This function is intended for client-side usage and utilizes `ClientFetch.makePsiRequest` to
 * communicate with the PSI service endpoint `shoppingcart.voucher.add`.
 * It sends the voucher code and version to the backend and returns the status of the operation.
 *
 * @param {string} voucherCode - The voucher code to add to the shopping cart.
 * @returns {Promise<{ status: string; sendStatus: boolean }>} A promise that resolves to the operation status.
 */
export const addVoucherToCart = async (voucherCode: string): Promise<{ status: string; sendStatus: boolean }> => {
  const payload = {
    voucherCode,
    version: 2,
  };

  return new ClientFetch().makePsiRequest<{ status: string; sendStatus: boolean }>('shoppingcart.voucher.add', payload, {
    method: HTTP_METHODS.POST,
  });
};

/**
 * Removes a voucher from the current shopping cart.
 *
 * This function is intended for client-side usage and utilizes `ClientFetch.makePsiRequest` to
 * communicate with the PSI service endpoint `shoppingcart.voucher.remove`.
 * It sends the voucher code and version to the backend and returns the status of the operation.
 *
 * @param {string} voucherCode - The voucher code to remove from the shopping cart.
 * @returns {Promise<{ status: string; sendStatus: boolean }>} A promise that resolves to the operation status.
 */
export const removeVoucherFromCart = async (voucherCode: string): Promise<{ status: string; sendStatus: boolean }> => {
  const payload = {
    voucherCode,
    version: 2,
  };

  return new ClientFetch().makePsiRequest<{ status: string; sendStatus: boolean }>('shoppingcart.voucher.remove', payload, {
    method: HTTP_METHODS.POST,
  });
};
